import { useState, useEffect } from 'react';

/**
 * Hook pour gérer le statut des intégrations externes
 * Récupère les informations de connexion JIRA/GitHub/GitLab
 */
export const useIntegrations = () => {
  const [integrations, setIntegrations] = useState({
    atlassian: { connected: false, domain: null, email: null, lastSync: null },
    github: { connected: false, username: null, lastSync: null },
    gitlab: { connected: false, domain: null, username: null, lastSync: null }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchIntegrationStatus = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/integration/status', {
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération du statut des intégrations');
      }

      const data = await response.json();
      setIntegrations(data.integrations);
      setError(null);
    } catch (err) {
      console.error('Erreur useIntegrations:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIntegrationStatus();
  }, []);

  const refreshIntegrations = () => {
    fetchIntegrationStatus();
  };

  return {
    integrations,
    loading,
    error,
    refreshIntegrations
  };
};
